import Header from "../Component/UserEnd/Header";
import HomeTitle from "../Component/UserEnd/HomeTitle";
import HomeAbout from "../Component/UserEnd/HomeAbout";
import HomeWork from "../Component/UserEnd/HomeWork";
import HomeExclusive from "../Component/UserEnd/HomeExclusive";
import HomeServices from "../Component/UserEnd/HomeServices";
import WhyUs from "../Component/UserEnd/WhyUs";
import Testimonial from "../Component/UserEnd/Testimonial";
import Footer from "../Component/UserEnd/Footer";
function Home() {
  return (
    <>
      <Header />
      <HomeTitle />
      <HomeAbout />
      <HomeWork />
      <HomeExclusive />
      <HomeServices />
      <WhyUs />
      <Testimonial />
      <Footer />
    </>
  );
}

export default Home;
